import React, { useEffect } from "react";
import "./DrawButton.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faVectorSquare,
  faGenderless,
  faWindowMinimize,
  faCircle,
  faDrawPolygon,
  faSlash,
  faXmark,
  faRulerHorizontal,
  faFont,
  faToolbox,
} from "@fortawesome/free-solid-svg-icons";
library.add(
  faVectorSquare,
  faGenderless,
  faWindowMinimize,
  faCircle,
  faDrawPolygon,
  faSlash,
  faXmark,
  faRulerHorizontal,
  faFont,
  faToolbox
);

const icons = {
  point: faCircle,
  polyline: faWindowMinimize,
  polygon: faDrawPolygon,
  circle: faGenderless,
  rectangle: faVectorSquare,
  text: faFont,
  measureTool: faToolbox,
  none: faXmark,
};

const DrawButton = (props) => {
  if (props.visible !== undefined && !props.visible) return <div />;

  return (
    <div
      className={
        props.isActive
          ? "sc-mymaps-button-container active"
          : "sc-mymaps-button-container"
      }
    >
      <button
        className={
          props.disabled === undefined || !props.disabled
            ? "sc-mymaps-button"
            : "sc-mymaps-button disabled"
        }
        title={props.title}
        onClick={props.onClick}
        disabled={
          props.disabled === undefined || !props.disabled ? false : true
        }
      >
        <FontAwesomeIcon
          icon={icons[props.imageName]}
          className={`faIcons 
          ${props.imageName === "point" ? "smallCircle" : ""} 
          ${props.imageName === "polyline" ? "faLine" : ""}
          ${props.imageName === "circle" ? "faCircle" : ""}
          ${props.imageName === "none" ? "faXmark" : ""}`}
        />
      </button>
    </div>
  );
};

export default DrawButton;

// IMPORT ALL IMAGES
const images = importAllImages(
  require.context("./images", false, /\.(png|jpe?g|svg)$/)
);
function importAllImages(r) {
  let images = {};
  r.keys().map((item, index) => (images[item.replace("./", "")] = r(item)));
  return images;
}
